import Model from '@/models/Model'

export default class SlCustomerBranchOffice extends Model {
    resource() {
        return 'sl_customer_branch_offices'
    }

    fetchByCustomerId(id) {
        return this.where('sl_customer_id', id)
            .include(
                'g_commune',
                'sl_customer_ground_seller.sl_ground_seller.hr_employee.g_user'
            )
            .get()
    }
}
